(function () {
  'use strict';

  if (window.__rrCollectionSortDelegated) {
    return;
  }

  window.__rrCollectionSortDelegated = true;

  var sortSelector = '.m-sort--toolbar';

  function closeMenus(except) {
    document.querySelectorAll('.js-collection-sort-menu').forEach(function (menu) {
      if (menu !== except) {
        menu.hidden = true;
        var trigger = menu.parentElement.querySelector('.js-collection-sort-trigger');
        if (trigger) {
          trigger.setAttribute('aria-expanded', 'false');
        }
      }
    });
  }

  function updateOptionState(sort, value) {
    sort.querySelectorAll('.js-collection-sort-option').forEach(function (option) {
      option.setAttribute('aria-selected', option.dataset.sortValue === value ? 'true' : 'false');
    });
  }

  function getSortQuery(select) {
    var form = select.closest('form');
    var params = new URLSearchParams();

    if (form) {
      new FormData(form).forEach(function (value, key) {
        if (key !== 'sort_by' && value !== '') {
          params.append(key, value);
        }
      });
    }

    params.set('sort_by', select.value);
    return params;
  }

  function updateProducts(sort, select) {
    var grid = document.querySelector('.js-product-grid-products');
    var container = document.querySelector('.js-product-grid-container');
    var params = getSortQuery(select);
    var query = params.toString();
    var sectionId = grid && grid.dataset.id;
    var requestUrl = window.location.pathname + '?section_id=' + encodeURIComponent(sectionId || '') + '&' + query;

    if (!container || !sectionId) {
      window.location.href = window.location.pathname + '?' + query;
      return;
    }

    container.classList.add('loading');

    fetch(requestUrl)
      .then(function (response) {
        if (!response.ok) {
          throw new Error('Sort request failed');
        }
        return response.text();
      })
      .then(function (html) {
        var parsed = new DOMParser().parseFromString(html, 'text/html');
        var nextContainer = parsed.querySelector('.js-product-grid-container');

        if (!nextContainer) {
          throw new Error('Sorted product grid was not found');
        }

        container.innerHTML = nextContainer.innerHTML;

        var currentCount = document.getElementById('product-count');
        var nextCount = parsed.getElementById('product-count');
        if (currentCount && nextCount) {
          currentCount.innerHTML = nextCount.innerHTML;
        }

        window.history.pushState({ searchParams: query }, '', window.location.pathname + '?' + query);
        if (window.WhatSub && typeof window.WhatSub.dispatch === 'function') {
          window.WhatSub.dispatch('RENDER_PRODUCTS');
          window.WhatSub.dispatch('UPDATE_SORTING');
        }
      })
      .catch(function () {
        window.location.href = window.location.pathname + '?' + query;
      })
      .finally(function () {
        container.classList.remove('loading');
      });
  }

  document.addEventListener('click', function (event) {
    var target = event.target instanceof Element ? event.target : event.target.parentElement;
    var trigger = target && target.closest('.js-collection-sort-trigger');
    var option = target && target.closest('.js-collection-sort-option');

    if (trigger) {
      var triggerSort = trigger.closest(sortSelector);
      var triggerMenu = triggerSort && triggerSort.querySelector('.js-collection-sort-menu');

      if (!triggerSort || !triggerMenu) {
        return;
      }

      event.preventDefault();
      var isOpen = !triggerMenu.hidden;
      closeMenus(isOpen ? null : triggerMenu);
      triggerMenu.hidden = isOpen;
      trigger.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
      return;
    }

    if (option) {
      var optionSort = option.closest(sortSelector);
      var optionMenu = optionSort && optionSort.querySelector('.js-collection-sort-menu');
      var select = optionSort && optionSort.querySelector('select[name="sort_by"]');

      if (!optionSort || !optionMenu || !select) {
        return;
      }

      event.preventDefault();
      select.value = option.dataset.sortValue;
      updateOptionState(optionSort, select.value);
      optionMenu.hidden = true;
      var optionTrigger = optionSort.querySelector('.js-collection-sort-trigger');
      if (optionTrigger) {
        optionTrigger.setAttribute('aria-expanded', 'false');
      }
      updateProducts(optionSort, select);
      return;
    }

    if (!target || !target.closest('.m-sort--toolbar')) {
      closeMenus(null);
    }
  });
}());
